import { Container } from '../ListProducts.styles';

const ListProductsError = () => {
  return <Container>Error on load products</Container>;
};

export { ListProductsError };
